<template>
    <div class="loading large">
        <i class="fa fa-refresh fa-spin"></i>
        <p>Loading</p>
    </div>
</template>

<script>
    export default {
        name: 'LoadingLarge'
    }
</script>


// WEBPACK FOOTER //
// LoadingLarge.vue?2249e427